import { SUPPORT_CHAT_URL } from "@/constants/global-constants";
import { VariantContext } from "@/variants/context";
import { useContext } from "react";

export const PageReloadErrorMessage = () => {
  const variant = useContext(VariantContext);
  const appName = variant?.appName || "this";
  const supportEmail = variant?.branding?.supportEmail;

  return <div style={{ padding: '16px' }}>
    Please <strong>Refresh the page</strong> or Go Back to the Home Page by clicking {appName} App in the "Apps" section in the left sidebar.
    <>
      <br />If the problem persists, please contact support:{" "}
      <a href={SUPPORT_CHAT_URL} target="_blank" rel="noreferrer">Live Chat</a>
      {supportEmail && " or "}
      {supportEmail && <strong>{supportEmail}</strong>}
    </>
  </div>;
}
